// extracted by mini-css-extract-plugin
export var cardHeader = "_tf-0";
export var reorderHandle = "_tf-3";
export var titleArea = "_tf-1";
export var titleAreaWithHandle = "_tf-2";